routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.productNotFound', {
      url: "product-not-found/{productSearchText}",
      template: `<product-not-found sh-ctrl="shCtrl"></product-not-found>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-not-found/product-not-found.config.js
 **/